import { FC } from 'react';
import { SelectOption } from 'global';
import { LenderProfiles } from '@trnsact/trnsact-shared-types/src/generated';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/business-criteria';
import { FinanceProgramForm, FinanceProgramTierForm } from './schema';
import { FinanceProgram, FinanceProgramInsuranceCoverage } from '@trnsact/trnsact-shared-types';
import { UseFormReturn } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';

export enum FinanceProgramFormSteps {
  First = 1,
  Second = 2,
}

export enum FinanceProgramFormMode {
  Create = 'create',
  Update = 'update',
}

export enum Structures {
  None = 'none',
  Markup = 'financeProfit',
  Subsidy = 'subsidy',
}

export enum MarkupMethods {
  Markup = 'markup',
  CustomerRate = 'customerRate',
}

export interface StepsActionsConfig {
  step: FinanceProgramFormSteps;
  disabled?: boolean;
}

export interface StepsConfig {
  label: string;
  isValid: boolean;
  step: FinanceProgramFormSteps;
}

export type LenderOptions = LenderProfiles & SelectOption;
export type FinanceCriteriaOptions = SelectOption & {
  formRules: any[];
  createdDateTime: any;
};

export enum ConditionsFieldsTypes {
  Boolean = 'boolean',
  Number = 'number',
  String = 'string',
}

export type AllRules = FACT_NAMES_BOOLEAN | FACT_NAMES_NUMERIC | FACT_NAMES_STRING;

export type SectionStatus = Record<
  'details' | 'criteria' | 'insuranceCoverage' | 'structure' | 'docs' | 'submissionSettings',
  boolean
>;

export interface ConfirmSummaryRenderConfig {
  label: string;
  sectionKey: keyof SectionStatus;
  component: FC<{
    financeProgramFormValues: FinanceProgramForm['program'];
    isLenderCreditAppSettingVisible?: boolean;
  }>;
}

export interface FinanceFormModalData {
  isReadOnly?: boolean;
  targetLenders?: string[];
  isMultipleLenders?: boolean;
  userType?: 'lender' | 'dealer';
  lendersOptions: LenderProfiles[];
  dealerVendorProfileOptions?: any[];
  isLendersSelectDisabled?: boolean;
  program?: FinanceProgramForm['program'];
  criteriaOptions: FinanceCriteriaOptions[];
  lpsWithOcaAccessByLenderProfileId?: Record<string, LenderProfiles>;
  onSubmit: (formValue: FinanceProgramForm) => Promise<void>;
}

export interface PreviewFinanceFormModalData {
  program: FinanceProgramForm['program'];
  disableButton?: React.ReactNode;
  lpsWithOcaAccessByLenderProfileId?: Record<string, LenderProfiles>;
  onEdit?: VoidFunction;
}

export type InsuranceLabelsByKey = Omit<Record<keyof FinanceProgramInsuranceCoverage, string>, '__typename'>;

export type Fee = FinanceProgramForm['program']['second']['fee'][number];

export interface QuoteProgramDialogData {
  financePrograms: FinanceProgram[];
  lenderProfileId: string;
  onConfirm: (lenderProfileId: string, financeProgramId: string) => void;
}

export interface QuoteProgramDialogFormValues {
  financeProgramId: string;
}

export interface FinanceProgramTiersTableContext {
  form: UseFormReturn<ListingForm<FinanceProgramTierForm>>;
}
